// extracted by mini-css-extract-plugin
export const tooltipContainer = "tooltip-module--tooltip-container--1V3sL";
export const tooltipTitle = "tooltip-module--tooltip-title--eI9jz";
export const tooltipTextContainer = "tooltip-module--tooltip-text-container--ZhHMO";
export const tooltipText = "tooltip-module--tooltip-text--B0o1S";